let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7j92c")).then(() => parcelRequire('lFVl2'));